import { messages } from '@qality/common-messages';
import { StorageOfUniqueServices } from '@qality/common-service';

export default {
  openDeleteStepDialog(onDeleteTestStep: () => Promise<void>): void {
    window.AP.dialog
      .create({
        key: 'delete-test-step-dialog',
        size: 'maximum',
        chrome: false,
        header: 'Delete Test Step',
        submitText: messages['testStep.actions.delete.buttonLabel'],
      })
      .on('close', onDeleteDialogClose.bind(onDeleteTestStep));
  },
};

export function onDeleteDialogClose(canDelete: boolean): void {
  if (canDelete) {
    deleteTestStep(this);
  }
}

async function deleteTestStep(
  onDeleteTestStep: () => Promise<void>
): Promise<void> {
  try {
    await onDeleteTestStep();
  } catch (e) {
    StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
      e,
      messages['error.testCases.deleteTestStep.message']
    );
  }
}
